import React, { FC, ReactNode, useRef } from 'react';
import { Button } from '@mui/material';
//--
import './SCUIButton.scss';
interface IProps {
    onClick?: () => void;
    type: 'primary' | 'secondary' | 'ghost' | 'error';
    buttonType?: string;
    sizeType: 'icon' | 'default' | 'fixed';
    size: 's' | 'm' | 'l';
    children?: ReactNode;
    className?: string;
    style?: React.CSSProperties;
    text: string;
    disabled?: boolean;
    textStatusIsLeft?: boolean;
    showStartIcon?: boolean;
    showEndIcon?: boolean;
    startIcon?: any;
    endIcon?: any;
    fullwidth?: boolean;
    href?: any;
    autoFocusButton?: any;
}

export const SCUIButton: FC<IProps> = ({
    onClick,
    type = 'primary',
    buttonType = 'submit',
    sizeType = 'default',
    size = 'm',
    children,
    className = '',
    style = undefined,
    text,
    disabled,
    textStatusIsLeft = false,
    showStartIcon = false,
    showEndIcon = false,
    startIcon,
    endIcon,
    fullwidth = false,
    href,
    autoFocusButton,
}) => {
    const refInputFile = useRef<any>();

    const isChildNull = (children: ReactNode) => {
        return Boolean(children === null);
    };

    const onClickBtn = () => {
        const inputElement = refInputFile.current;
        if (onClick) {
            inputElement.click();
            onClick();
        }
    };
    const _renderFileButton = () => {
        return (
            <div className="sc-file-btn">
                <input
                    accept="image/*"
                    className={'hidden'}
                    id="contained-button-file"
                    multiple
                    type="file"
                    ref={refInputFile}
                />
                <label htmlFor="contained-button-file">
                    <Button
                        className={`btn sc-btn  sc-btn-${type} sc-btn-${sizeType}  sc-btn-${sizeType}--${size} ${className}`}
                        onClick={onClickBtn}
                        disabled={disabled}
                        style={style}
                    >
                        {textStatusIsLeft && <p className="sc-btn__text">{text}</p>}
                        {!isChildNull(children) && <div className="sc-btn__content">{children}</div>}
                        {!textStatusIsLeft && <p className="sc-btn__text">{text}</p>}
                    </Button>
                </label>
            </div>
        );
    };

    const _renderDefaultButton = () => {
        return (
            <Button
                className={`btn sc-btn  sc-btn-${type} sc-btn-${sizeType}  sc-btn-${sizeType}--${size} ${className}`}
                style={style}
                fullWidth={fullwidth}
                onClick={onClick}
                disabled={disabled}
                type={buttonType}
                startIcon={showStartIcon ? startIcon : null}
                endIcon={showEndIcon ? endIcon : null}
                href={href}
                variant={type === 'primary' ? 'contained' : type === 'secondary' ? 'outlined' : 'text'}
                autoFocus={autoFocusButton}
            >
                {textStatusIsLeft && <p className="sc-btn__text">{text}</p>}
                {!isChildNull(children) && <div className="sc-btn__content">{children}</div>}
                {!textStatusIsLeft && <p className="sc-btn__text">{text}</p>}
            </Button>
        );
    };

    return buttonType === 'file' ? _renderFileButton() : _renderDefaultButton();
};
